import { useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash';
import { t, Trans } from '@lingui/macro';
import { COLUMN_TYPES } from '../data-table/DataTableColumns';
import { SORT_ASC } from '../../utilities/FormUtilities';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';
import DataTable from '../data-table/DataTable';
import { ROWSIZE } from '../data-table/DataTableConstants';
import { SELECTIONMODE_SINGLE } from '../data-table/SelectionContext';
import { useArrayLoader } from '../data-table/Loaders';
import { useFilterControl } from '../page-framework/filter/FilterControl';

const beaconStepsDialog = t`Smart Edge Monitoring`;

const gridColumns = [
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Step`,
        sortable: true,
        mapping: 'metricTitle',
        width: 200,
    },
    {
        type: COLUMN_TYPES.TEXT,
        sortable: true,
        mapping: 'nameForNg1',
        width: 500,
    },
];

const initialSort = [{ property: 'metricId', direction: SORT_ASC }];

export default function Ng1BeaconStepsDialog({ beaconSteps, showDialog, setShowDialog, updateSelection }) {
    const filterControl = useFilterControl();
    const beaconStepsLoader = useArrayLoader(beaconSteps);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [tableSelection, setTableSelection] = useState(undefined);
    const [tableState, setTableState] = useState(undefined);

    const columns = useMemo(() => setNotResizable(gridColumns), []);

    const handleConfirm = () => {
        const selections = [...tableSelection.selection];
        updateSelection(selections, tableState);
        setShowDialog(false);
    };

    const handleTableSelectionChange = (currentTableSelection) => {
        setTableSelection(currentTableSelection);
        setConfirmDisabled(
            !currentTableSelection || (isEmpty(currentTableSelection.selection) && !currentTableSelection.inverted)
        );
    };

    function setNotResizable(cols) {
        return cols.map((c) => {
            return { ...c, resizable: false };
        });
    }

    // Pause filter auto-refresh when the dialog is visible.  This prevents tables from reloading while the dialog
    // is visible.  Without this, the dialog would be closed each time the filters auto-refresh.
    useEffect(() => {
        if (showDialog) {
            filterControl.pauseAutoRefresh();
        } else {
            filterControl.resumeAutoRefresh();
        }
    }, [showDialog, filterControl]);

    return (
        <NgpTwoButtonDialog
            title={beaconStepsDialog}
            confirmButtonText={<Trans>Launch</Trans>}
            cancelButtonText={<Trans>Cancel</Trans>}
            open={showDialog}
            setOpen={setShowDialog}
            confirmButtonDisabled={confirmDisabled}
            callerWillCloseOnConfirm
            onConfirm={handleConfirm}
        >
            <DataTable
                loader={beaconStepsLoader}
                columns={columns}
                showSearch={false}
                emptyText={t`No SEM metrics are enabled for the test`}
                disableCSVExport
                disableColumnRemover
                showSelectionColumn
                rowSize={ROWSIZE.SMALL}
                sorters={initialSort}
                visibleRows={9}
                shrink={false}
                onStateChanged={setTableState}
                selectionOptions={{
                    mode: SELECTIONMODE_SINGLE,
                    allowSelectAll: false,
                    idMapping: 'locationKeyId',
                    onChange: handleTableSelectionChange,
                }}
            />
        </NgpTwoButtonDialog>
    );
}
